/**
 * Normaliza valores monetários em formato brasileiro para float nativo
 * Ex: "R$ 1.500,55" -> 1500.55
 * @param {string|number} valorStr 
 * @returns {number|null} Valor numérico float
 */
export const normalizarValor = (valorStr) => {
    if (valorStr === null || valorStr === undefined || String(valorStr).trim() === '') return null;
    if (typeof valorStr === 'number') return valorStr;

    let limpo = String(valorStr).replace(/[^\d,.-]/g, '');
    
    if (limpo.includes(',') && limpo.includes('.')) {
        limpo = limpo.replace(/\./g, '').replace(',', '.');
    } else if (limpo.includes(',')) {
        const partes = limpo.split(',');
        if (partes[1] && partes.length === 2) {
            limpo = limpo.replace(',', '.');
        } else {
            limpo = limpo.replace(',', '');
        }
    }
    
    const valor = parseFloat(limpo);
    return isNaN(valor) ? null : valor;
};
